import React from "react";
import { FaGithub, FaLinkedin } from "react-icons/fa";
import { HiOutlineMail } from "react-icons/hi";
import { BsFillPersonLinesFill } from "react-icons/bs";
import resumePdf from "../assets/resume.pdf";

const SocialLinks = () => {
  const links = [
    {
      id: 1,
      label: "LinkedIn",
      icon: <FaLinkedin size={20} />,
      href: "https://www.linkedin.com/in/raj-pal-a052211b5/",
    },
    {
      id: 2,
      label: "GitHub",
      icon: <FaGithub size={20} />,
      href: "https://github.com/Raj-Stark",
    },
    {
      id: 3,
      label: "Mail",
      icon: <HiOutlineMail size={21} />,
      href: "mailto:rpal778866@gmail.com",
    },
    {
      id: 4,
      label: "Resume",
      icon: <BsFillPersonLinesFill size={19} />,
      href: resumePdf,
      download: true,
    },
  ];

  return (
    <aside className="fixed left-4 top-1/2 z-40 hidden -translate-y-1/2 flex-col gap-2 lg:flex">
      {links.map(({ id, label, icon, href, download }) => (
        <a
          key={id}
          href={href}
          download={download}
          target="_blank"
          rel="noreferrer"
          aria-label={label}
          title={label}
          className="flex h-11 w-11 items-center justify-center rounded-full border border-white/10 bg-[#111719] text-zinc-300 shadow-lg shadow-black/20 transition hover:-translate-y-0.5 hover:border-emerald-300 hover:text-emerald-200"
        >
          {icon}
        </a>
      ))}
    </aside>
  );
};

export default SocialLinks;
